export var SettingsRoutes = {
    "/settings": {
        "enableUTM": true,
        "name": "appLayout.harriSH.settings",
        "type": "frontend",
        "stopBrandSwitchRedirect": true,
        "templateUrl": "../modules/settings/views/settings.html",
        "controller": 'SettingsController',
        "loginRequired": true,
        "showGlobalSearch": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["permission_management", "authority_to_recruit", "rejection_templates", "restricted_positions", "branded_comms", "document_uploader", "custom_sources", "offer_templates", "chat_bot", "auto_wage_matrix", "enterprise_communication_settings", "tl_reports_settings", "blocked_terminated_employees", "hr_actions_templates", "custom-docs", "job-screening-templates", "centralized-settings", "ams_columns_settings"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./settings.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/pos-integration/pos-integration.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/branded-comms/branded-comms.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/blocked-terminated-employees/blocked-terminated-employees.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/auto-wage-matrix/auto-wage-matrix.module.js');
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/hyper-hire/hyperhire.module.js");
                }
            },{
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/mice/mice.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/job-approval/job-approval.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/custom-docs/custom-docs.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/offer-templates/offer-templates.module.js')
                }
            },
        ],
        "onEnter": ['$state', '$stateParams', '$location', 'useNavFactory', 'useSettingsNav', 'hUser', async ($state, $stateParams, $location, useNavFactory, useSettingsNav, hUser) => {
            if (hUser.isEmployer()) {
                const navFactory = useNavFactory();
                return navFactory.init(useSettingsNav().settingsNav)
                    .then(() => {
                        if (!$stateParams.view && navFactory.state.activeNavs.length) {
                            const item = navFactory.state.activeNavs[0][0].filteredSections[0].items[0];
                            setTimeout(() => {
                                Utils.goToUrl(item.href());
                            }, 100);
                        } else if (hUser.isTopLevelContext()) {
                            Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main');
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            }
        }],
    },

    "/tl/edit/profile/:view": {
        "enableUTM": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.editprofile",
        "type": "frontend",
        "params": {
            view: {
                dynamic: true,
                value: ''
            }
        },
        "views": {
            "body": {
                "templateUrl": "../modules/settings/views/settings.html",
                "controller": 'SettingsController',
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['edit-profile', 'centralized-settings']
        },
        "loginRequired": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./settings.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/pos-integration/pos-integration.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/branded-comms/branded-comms.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/auto-wage-matrix/auto-wage-matrix.module.js');
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/hyper-hire/hyperhire.module.js");
                }
            },{
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/mice/mice.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/job-approval/job-approval.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/edit-profile/edit-profile.module.js");
                }
            }
        ],
        "resolve": {
            brandsList: ['settingsFactory', function (settingsFactory) {
                return {data: {data: {}}};
            }]
        }
    },

    "/edit/profile/:view": {
        "enableUTM": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.editprofile",
        "type": "frontend",
        "params": {
            view: {
                dynamic: true,
                value: ''
            }
        },
        "templateUrl": "../modules/settings/views/settings.html",
        "controller": 'SettingsController',
        "loginRequired": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['edit-profile', 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./settings.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/pos-integration/pos-integration.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/branded-comms/branded-comms.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/auto-wage-matrix/auto-wage-matrix.module.js');
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/hyper-hire/hyperhire.module.js");
                }
            },{
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/mice/mice.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/job-approval/job-approval.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import('../../hmodules/edit-profile/edit-profile.module.js')
                },
            }
        ],
        "resolve": {
            brandsList: ['settingsFactory', function (settingsFactory) {
                return {data: {data: {}}};
            }]
        },
        "onEnter": [() => {
            $(".modal-backdrop").remove();
        }]
    },

    "/:view?tab&section": {
        "name": "appLayout.harriSH.settings.section",
        "type": "frontend",
        "loginRequired": true,
        "showGlobalSearch": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["permission_management", "authority_to_recruit", "rejection_templates", "restricted_positions", "branded_comms", "document_uploader", "custom_sources", "offer_templates", "mice", "chat_bot", "auto_wage_matrix", "enterprise_communication_settings", "blocked_terminated_employees", "hr_actions_templates", "custom-docs", "tl_reports_settings", "job-screening-templates", "centralized-settings", "ams_columns_settings"]
        },
    },
    "/:view?tab": {
        "name": "appLayout.harriSH.settings.brandSection",
        "type": "frontend",
        "loginRequired": true,
        "showGlobalSearch": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["permission_management", "authority_to_recruit", "rejection_templates", "restricted_positions", "branded_comms", "document_uploader", "custom_sources", "offer_templates", "mice", "chat_bot", "auto_wage_matrix", "enterprise_communication_settings", "blocked_terminated_employees", "hr_actions_templates", "custom-docs", "tl_reports_settings", "job-screening-templates", "centralized-settings", "ams_columns_settings"]
        },
    }
};
